/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { userPreferencesControllerGetUserPreferences } from "./userPreferencesControllerGetUserPreferences";
import { userPreferencesControllerIncrementOnboardingTasksLoginViews } from "./userPreferencesControllerIncrementOnboardingTasksLoginViews";
import { userPreferencesControllerUpdateUserPreferences } from "./userPreferencesControllerUpdateUserPreferences";

export function userPreferencesService() {
  return { userPreferencesControllerGetUserPreferences, userPreferencesControllerUpdateUserPreferences, userPreferencesControllerIncrementOnboardingTasksLoginViews }
}